import { ReactComponent as AlertPrimaryImg } from "assets/images/alert-primary.svg";
import { ReactComponent as AlertSecondaryImg } from "assets/images/alert-secondary.svg";
import { ReactComponent as AlertInfoImg } from "../assets/images/alert-info.svg";
import { ReactComponent as AlertSuccessImg } from "assets/images/alert-success.svg";
import { ReactComponent as AlertDangerImg } from "assets/images/alert-danger.svg";
import { ReactComponent as AlertWarningImg } from "assets/images/alert-warning.svg";

export const BASE_URL = process.env.REACT_APP_API_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const GRANT_TYPE = Object.freeze({
  PASSWORD: "password",
  REFRESH_TOKEN: "refresh_token",
});
export const initialMetaForTable = {
  page: 1,
  perPage: 10,
  search: "",
};

export const toastContainerProps = {
  hideProgressBar: true,
  closeButton: false,
  autoClose: 5000,
  limit: 2,
  position: "bottom-right",
  closeOnClick: false,
};

export const alertTypes = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
};

export const alertIcons = {
  [alertTypes.INFO]: <AlertInfoImg />,
  [alertTypes.DANGER]: <AlertDangerImg />,
  [alertTypes.WARNING]: <AlertWarningImg />,
  [alertTypes.SUCCESS]: <AlertSuccessImg />,
  [alertTypes.PRIMARY]: <AlertPrimaryImg />,
  [alertTypes.SECONDARY]: <AlertSecondaryImg />,
};
export const statusBadgeStyles = {
  created: {
    text: "Created",
    className: "badge bg-warning bg-opacity-25 text-warning",
    barColor: "#ffc107",
  },
  submitted: {
    text: "Submitted",
    className: "badge bg-secondary bg-opacity-25 text-secondary",
    barColor: "#ffc107",
  },
  confirmed_payment: {
    text: "Confirmed Payment",
    className: "badge bg-success bg-opacity-25 text-success",
    barColor: "#28a745",
  },
  approved: {
    text: "Approved",
    className: "badge bg-success bg-opacity-25 text-success",
    barColor: "#28a745",
  },
  denied: {
    text: "Denied",
    className: "badge bg-danger bg-opacity-25 text-danger",
    barColor: "#dc3545",
  },
  resubmitted: {
    text: "Resubmitted",
    className: "badge bg-primary bg-opacity-25 text-primary",
    barColor: "#0d6efd",
  },
  completed: {
    text: "Completed",
    className: "badge bg-info bg-opacity-25 text-info",
    barColor: "#0dcaf0",
  },
  pending: {
    text: "Pending",
    className: "badge bg-secondary bg-opacity-25 text-muted",
    barColor: "#adb5bd",
  },
};
export const statusBadge = {
  draft: { className: "status draft", label: "Draft" },
  submitted: { className: "status submitted", label: "Submitted" },
  pending: { className: "status pending", label: "Pending" },
  approved: { className: "status approved", label: "Approved" },
  completed: { className: "status completed", label: "Completed" },
  cancelled: { className: "status cancelled", label: "Cancelled" },
  denied: { className: "status denied", label: "Denied" },
};

export const DEBOUNCE_DELAY = 700;

export const question_type = {
  dropdown: "dropdown",
  multiple_choice: "multiple_choice",
  input: "text",
  checkbox: "checkbox",
  text: "text",
  multi_select: "multi_select",
  dynamic: "dynamic",
  date: "date",
  phone: "phone",
  time_range: "time_range",
};

export const LOGIN_ROLES = {
  outreachleader: "OutreachLeader",
  outreachstaff: "OutreachStaff",
};
export const martial_statusOptions = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
  { value: "separated", label: "Separated" },
  { value: "domestic_partner", label: "Domestic Partner" },
  { value: "prefer_not_say", label: "Prefer Not to Say" },
];
export const referringProviderOptions = [
  { value: "maria_ramirez", label: "Maria Ramirez, Program Director" },
  { value: "david_nguyen", label: "David Nguyen, Outreach Manager" },
  { value: "lisa_tran", label: "Lisa Tran, Shelter Coordinator" },
  { value: "jamal_wright", label: "Jamal Wright, Community Lead" },
  { value: "rachel_lee", label: "Rachel Lee, Program Director" },
];
export const referralProgramOptions = [
  { value: "ecm", label: "ECM" },
  { value: "cs_housing", label: "CS Housing" },
  { value: "recuperative_care", label: "Recuperative Care" },
  { value: "short_term_hospitalization", label: "Short Term Hospitalization" },
];

export const existingProgramEnrollments = [
  { value: "bay_area_housing_support", label: "Bay Area Housing Support" },
  { value: "la_homeless_aid", label: "Los Angeles Homeless Aid" },
  { value: "sacramento_shelter_network", label: "Sacramento Shelter Network" },
  { value: "oakland_outreach_services", label: "Oakland Outreach Services" },
  { value: "san_diego_safe_haven", label: "San Diego Safe Haven" },
];

export const programTypes = [
  { value: "ecm", label: "ECM" },
  { value: "cs_housing", label: "CS Housing" },
  { value: "recuperative_care", label: "Recuperative Care" },
  {
    value: "short_term_post_hospitalization",
    label: "Short Term Post Hospitalization",
  },
  { value: "no", label: "None" },
];

export const REFERRAL_STATUS = {
  Submitted: "submitted",
  Pending: "pending",
  Approved: "approved",
  Denied: "denied",
};

export const US_STATES = [
  { label: "AL", value: "AL" },
  { label: "AK", value: "AK" },
  { label: "AZ", value: "AZ" },
  { label: "AR", value: "AR" },
  { label: "CA", value: "CA" },
  { label: "CO", value: "CO" },
  { label: "CT", value: "CT" },
  { label: "DE", value: "DE" },
  { label: "FL", value: "FL" },
  { label: "GA", value: "GA" },
  { label: "HI", value: "HI" },
  { label: "ID", value: "ID" },
  { label: "IL", value: "IL" },
  { label: "IN", value: "IN" },
  { label: "IA", value: "IA" },
  { label: "KS", value: "KS" },
  { label: "KY", value: "KY" },
  { label: "LA", value: "LA" },
  { label: "ME", value: "ME" },
  { label: "MD", value: "MD" },
  { label: "MA", value: "MA" },
  { label: "MI", value: "MI" },
  { label: "MN", value: "MN" },
  { label: "MS", value: "MS" },
  { label: "MO", value: "MO" },
  { label: "MT", value: "MT" },
  { label: "NE", value: "NE" },
  { label: "NV", value: "NV" },
  { label: "NH", value: "NH" },
  { label: "NJ", value: "NJ" },
  { label: "NM", value: "NM" },
  { label: "NY", value: "NY" },
  { label: "NC", value: "NC" },
  { label: "ND", value: "ND" },
  { label: "OH", value: "OH" },
  { label: "OK", value: "OK" },
  { label: "OR", value: "OR" },
  { label: "PA", value: "PA" },
  { label: "RI", value: "RI" },
  { label: "SC", value: "SC" },
  { label: "SD", value: "SD" },
  { label: "TN", value: "TN" },
  { label: "TX", value: "TX" },
  { label: "UT", value: "UT" },
  { label: "VT", value: "VT" },
  { label: "VA", value: "VA" },
  { label: "WA", value: "WA" },
  { label: "WV", value: "WV" },
  { label: "WI", value: "WI" },
  { label: "WY", value: "WY" },
];

export const ORGANIZATION_TYPES = [
  { label: "Hospital", value: "hospital" },
  {
    label: "Community Based Organization",
    value: "community_based_organization",
  },
  { label: "Healthcare Provider", value: "healthcare_provider" },
  { label: "Internal", value: "internal" },
  { label: "Medical Group/IPA", value: "medical_group/ipa" },
];
export const normalizeInput = (value, previousValue = 0) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6,
    )}-${currentValue.slice(6, 10)}`;
  }
};
// export const POPULATION_FOCUSES = [
//   { value: "elderly", label: "Elderly" },
//   { value: "disabled", label: "Disabled" },
//   { value: "veterans", label: "Veterans" },
//   { value: "low_income", label: "Low-Income" },
//   { value: "other_focus", label: "Other" },
// ];
export const POPULATION_FOCUSES = [
  {
    value: "adult_birth_equity",
    label: "Adult - Birth Equity Population of Focus",
  },
  {
    value: "adult_individual_experiencing_homelessness",
    label: "Adult - Individual Experiencing Homelessness",
  },
  {
    value:
      "adults_without_dependents_youth_living_with_them_experiencing_homelessness",
    label:
      "Adults without Dependent Children Youth Living with Them Experiencing Homelessness",
  },
  {
    value: "adult_individual_experiencing_homelessness_homeless_family",
    label: "Adult - Individual Experiencing Homelessness Homeless Family",
  },
  {
    value: "adult_individuals_at_risk_avoidable_hospital_ed_utilization",
    label:
      "Adult - Individuals at Risk for Avoidable Hospital or ED Utilization",
  },
  {
    value:
      "adult_individuals_living_in_community_at_risk_for_ltc_institutionalization",
    label:
      "Adult - Individuals Living in the Community and at Risk for LTC Institutionalization",
  },
  {
    value: "adult_individuals_transitioning_from_incarceration",
    label: "Adult - Individuals Transitioning from Incarceration",
  },
  {
    value:
      "adult_individuals_serious_mental_health_or_substance_use_disorder_needs",
    label:
      "Adult - Individuals with Serious Mental Health or Substance Use Disorder (SUD) Needs",
  },
  {
    value: "adult_nursing_facility_residents_transitioning_to_community",
    label: "Adult - Nursing Facility Residents Transitioning to Community",
  },
  {
    value: "child_youth_birth_equity_population_of_focus",
    label: "Child Youth - Birth Equity Population of Focus",
  },
  {
    value:
      "child_youth_enrolled_ccs_ccs_wcm_additional_needs_beyond_ccs_condition",
    label:
      "Child Youth - Enrolled in CCS or CCS WCM with Additional Needs Beyond the CCS Condition",
  },
  {
    value: "child_youth_individual_experiencing_homelessness_homeless_family",
    label: "Child Youth - Individual Experiencing Homelessness Homeless Family",
  },
  {
    value: "child_youth_individuals_at_risk_avoidable_hospital_ed_utilization",
    label:
      "Child Youth - Individuals at Risk for Avoidable Hospital or ED Utilization",
  },
  {
    value:
      "child_youth_individuals_experiencing_homelessness_unaccompanied_children_youth_experiencing_homelessness",
    label:
      "Child Youth - Individuals Experiencing Homelessness Unaccompanied Children Youth Experiencing Homelessness",
  },
  {
    value: "child_youth_individuals_transitioning_from_incarceration",
    label: "Child Youth - Individuals Transitioning from Incarceration",
  },
  {
    value:
      "child_youth_individuals_serious_mental_health_or_substance_use_disorder_needs",
    label:
      "Child Youth - Individuals with Serious Mental Health or Substance Use Disorder (SUD) Needs",
  },
  {
    value: "child_youth_involved_in_child_welfare",
    label: "Child Youth - Involved in Child Welfare",
  },
];
export const CONDITIONS = [
  { value: "asthma", label: "Asthma" },
  { value: "bipolar_disorder", label: "Bipolar disorder" },
  {
    value: "chronic_congestive_heart_failure",
    label: "Chronic congestive heart failure",
  },
  { value: "chronic_kidney_disease", label: "Chronic kidney disease" },
  { value: "chronic_liver_disease", label: "Chronic liver disease" },
  {
    value: "chronic_obstructive_pulmonary_disease",
    label: "Chronic obstructive pulmonary disease",
  },
  { value: "coronary_artery_disease", label: "Coronary artery disease" },
  { value: "dementia", label: "Dementia" },
  { value: "diabetes", label: "Diabetes" },
  { value: "hypertension", label: "Hypertension" },
  { value: "psychotic_disorders", label: "Psychotic disorders" },
  { value: "smi_or_sud_or_sed", label: "SMI or SUD or SED" },
  { value: "traumatic_brain_injury", label: "Traumatic brain injury" },
  {
    value: "other_clinical_chronic_conditions",
    label: "Other Clinical Chronic Conditions",
  },
  { value: "na", label: "N/A" },
];

export const GENDER = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "othergender", label: "Other" },
  { value: "nonbinary", label: "Non-Binary" },
  {
    value: "prefernottosay",
    label: "Prefer Not to Say",
  },
  {
    value: "na",
    label: "NA",
  },
];
export const RACES = [
  { value: "asian", label: "Asian" },
  {
    value: "black_or_african_american",
    label: "Black or African American",
  },
  {
    value: "hispanic_or_latino",
    label: "Hispanic or Latino",
  },
  { value: "native_american", label: "Native American" },
  { value: "white", label: "White" },
  { value: "other", label: "Other" },
];
export const MARTIAL_STATUSES = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
  { value: "others", label: "Other" },
];
export const Housing_Navigator = [
  { value: "owner", label: "Owner" },
  { value: "renter", label: "Renter" },
  { value: "living_with_family", label: "Living with Family" },
  { value: "homeless", label: "Homeless" },
  { value: "other", label: "Other" },
];
// export const CONDITIONS = [
//   { value: "diabetes", label: "Diabetes" },
//   { value: "heart_disease", label: "Heart Disease" },
//   { value: "mental_health", label: "Mental Health" },
//   {
//     value: "physical_disability",
//     label: "Physical Disability",
//   },
//   { value: "other_condition", label: "Other" },
// ];

export const referral_status = [
  { label: "Submitted", value: "submitted" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Denied", value: "denied" },
];
export const defaultPaginationObject = {
  page: 1,
  per: 10,
};
export const orderStratergy = {
  asc: "desc",
  desc: "asc",
};
export const expense_request_status = [
  { label: "Draft", value: "draft" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Denied", value: "denied" },
  { label: "Completed", value: "completed" },
];

export const EMERGENCY_CONTACT_RELATIONSHIPS = [
  { value: "friend", label: "Friend" },
  { value: "partner", label: "Partner" },
  { value: "parent", label: "Parent" },
  { value: "sibling", label: "Sibling" },
  { value: "guardian", label: "Guardian" },
  { value: "other", label: "Other" },
];

export const PROGRAM_STATUS_OPTIONS = [
  { value: "inactive", label: "Inactive" },
  { value: "active", label: "Active" },
];

export const CALAIM_PROGRAMS = [
  {
    id: "calaim_css_housing_ie",
    name: "CalAIM - CSS Housing IE",
    statusField: "calaim_css_housing_ie_status",
    ifmrnField: "calaim_css_housing_ie_ifmrn",
  },
  {
    id: "calaim_css_housing_la",
    name: "CalAIM - CSS Housing LA",
    statusField: "calaim_css_housing_la_status",
    ifmrnField: "calaim_css_housing_la_ifmrn",
  },
  {
    id: "calaim_css_housing_oc",
    name: "CalAIM - CSS Housing OC",
    statusField: "calaim_css_housing_oc_status",
    ifmrnField: "calaim_css_housing_oc_ifmrn",
  },
  {
    id: "calaim_css_recup_ie",
    name: "CalAIM - CSS Recup IE",
    statusField: "calaim_css_recup_ie_status",
    ifmrnField: "calaim_css_recup_ie_ifmrn",
  },
  {
    id: "calaim_css_recup_la",
    name: "CalAIM - CSS Recup LA",
    statusField: "calaim_css_recup_la_status",
    ifmrnField: "calaim_css_recup_la_ifmrn",
  },
  {
    id: "calaim_css_recup_oc",
    name: "CalAIM - CSS Recup OC",
    statusField: "calaim_css_recup_oc_status",
    ifmrnField: "calaim_css_recup_oc_ifmrn",
  },
  {
    id: "calaim_css_short_term_ie",
    name: "CalAIM - CSS Short-Term Post-Hospitalization IE",
    statusField: "calaim_css_short_term_ie_status",
    ifmrnField: "calaim_css_short_term_ie_ifmrn",
  },
  {
    id: "calaim_css_short_term_la",
    name: "CalAIM - CSS Short-Term Post-Hospitalization LA",
    statusField: "calaim_css_short_term_la_status",
    ifmrnField: "calaim_css_short_term_la_ifmrn",
  },
  {
    id: "calaim_css_short_term_oc",
    name: "CalAIM - CSS Short-Term Post-Hospitalization OC",
    statusField: "calaim_css_short_term_oc_status",
    ifmrnField: "calaim_css_short_term_oc_ifmrn",
  },
  {
    id: "calaim_css_tenancy_ie",
    name: "CalAIM - CSS Tenancy/Sustainability IE",
    statusField: "calaim_css_tenancy_ie_status",
    ifmrnField: "calaim_css_tenancy_ie_ifmrn",
  },
  {
    id: "calaim_css_tenancy_la",
    name: "CalAIM - CSS Tenancy/Sustainability LA",
    statusField: "calaim_css_tenancy_la_status",
    ifmrnField: "calaim_css_tenancy_la_ifmrn",
  },
  {
    id: "calaim_css_tenancy_oc",
    name: "CalAIM - CSS Tenancy/Sustainability OC",
    statusField: "calaim_css_tenancy_oc_status",
    ifmrnField: "calaim_css_tenancy_oc_ifmrn",
  },
];

export const alertVariants = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
};
